// extracted by mini-css-extract-plugin
export default {"minimal":"styles-module--minimal--f0a5d","simple":"styles-module--simple--3f5cd","complex":"styles-module--complex--9b583"};